const accountType = {
  CONTA_CORRENTE: 'CONTA_CORRENTE',
  CONTA_POUPANCA: 'CONTA_POUPANCA',
  CONTA_FACIL: 'CONTA_FACIL',
  ENTIDADES_PUBLICAS: 'ENTIDADES_PUBLICAS'
};

module.exports = accountType;
